import { apiClient, OAUTH_BINDING_API_BASE } from '../../services/apiClient';

/**
 * Canva認証ステータス
 */
export interface CanvaAuthStatus {
  connected: boolean;
}

/**
 * Canva認証URL
 */
export interface CanvaAuthUrl {
  url: string;
}

/**
 * Canva編集レスポンス
 */
export interface CanvaEditResponse {
  edit_url: string;
  design_id: string;
}

/**
 * Canva編集エラーレスポンス
 */
export interface CanvaEditErrorResponse {
  error: string;
  need_auth?: boolean;
}

/**
 * Canva認証ステータスを取得
 */
export async function getCanvaAuthStatus(): Promise<CanvaAuthStatus> {
  const { data } = await apiClient.get<CanvaAuthStatus>('/canva/auth/status');
  return data;
}

/**
 * Canva認証URLを取得
 * @param materialId - 認証後に編集する素材ID（オプション）
 * @param isTemporary - 個人フォルダの素材かどうか
 */
export async function getCanvaAuthUrl(
  materialId?: string,
  isTemporary?: boolean
): Promise<CanvaAuthUrl> {
  const params = new URLSearchParams();
  if (materialId) {
    params.set('material_id', materialId);
    if (isTemporary) {
      params.set('is_temporary', 'true');
    }
  }
  const queryString = params.toString();
  const url = queryString ? `/canva/auth/url?${queryString}` : '/canva/auth/url';
  // 結合 Cookie を first-party にするため同一オリジン経由 (apiClient.ts 参照)
  const { data } = await apiClient.get<CanvaAuthUrl>(url, { baseURL: OAUTH_BINDING_API_BASE });
  return data;
}

/**
 * 素材をCanvaで編集
 */
export async function editInCanva(
  materialId: string,
  isTemporary: boolean = false
): Promise<CanvaEditResponse> {
  const { data } = await apiClient.post<CanvaEditResponse>('/canva/edit', {
    material_id: materialId,
    is_temporary: isTemporary,
  });
  return data;
}

/**
 * Canvaアカウントを切断
 */
export async function disconnectCanva(): Promise<{ success: boolean }> {
  const { data } = await apiClient.post<{ success: boolean }>('/canva/disconnect');
  return data;
}
